import { languageQuery } from '@gig/magic-common';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class EmbeddedMessagingService {
  constructor(config) {
    this.config = config;
    this.isLoaded = false;
    this.scriptLoaded = false;
  }
  loadEmbeddedMessaging() {
    return __async(this, null, function* () {
      if (this.isLoaded) {
        console.warn("Embedded Messaging is already loaded.");
        return;
      }
      try {
        if (!this.scriptLoaded) {
          yield this.appendScript();
          this.scriptLoaded = true;
        }
        yield this.initEmbeddedMessaging();
        this.isLoaded = true;
        yield this.waitForEmbeddedMessagingReady();
        yield this.launchChat();
      } catch (err) {
        console.error("Error loading Embedded Messaging:", err);
        throw err;
      }
    });
  }
  appendScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = this.config.sdkUrl;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error("Failed to load script."));
      document.body.appendChild(script);
    });
  }
  initEmbeddedMessaging() {
    return __async(this, null, function* () {
      const lang = yield languageQuery();
      if (typeof embeddedservice_bootstrap === "undefined") {
        throw new Error("Embedded Messaging bootstrap script is not loaded.");
      }
      embeddedservice_bootstrap.settings.language = this.config.language || lang;
      embeddedservice_bootstrap.settings.chatButtonPosition = "80px,20px";
      embeddedservice_bootstrap.init(this.config.orgId, this.config.embeddedServiceName, this.config.baseURL, { scrt2URL: this.config.scrt2URL });
    });
  }
  waitForEmbeddedMessagingReady(maxAttempts = 30, interval = 500) {
    return new Promise((resolve, reject) => {
      const checkReady = (attempts = 0) => {
        if (this.isEmbeddedMessagingReady()) {
          resolve();
        } else if (attempts < maxAttempts) {
          setTimeout(() => checkReady(attempts + 1), interval);
        } else {
          reject(new Error("Timeout waiting for Embedded Messaging to be ready."));
        }
      };
      checkReady();
    });
  }
  isEmbeddedMessagingReady() {
    return typeof embeddedservice_bootstrap !== "undefined" && embeddedservice_bootstrap.utilAPI && typeof embeddedservice_bootstrap.utilAPI.launchChat === "function";
  }
  launchChat() {
    return __async(this, null, function* () {
      if (!this.isEmbeddedMessagingReady()) {
        throw new Error("Embedded Messaging is not ready for chat launch.");
      }
      yield embeddedservice_bootstrap.utilAPI.launchChat();
    });
  }
}

export { EmbeddedMessagingService };
